import React from 'react';
import UsersEditContain from '../../Componant/Users/UsersEdit';

const UserEdit = () => {
  return (
    <div className='page-body'>
      <UsersEditContain />
    </div>
  );
};

export default UserEdit;
